module.exports = __webpack_public_path__ + "img/kr-product-agency-card4-1.2fc501b.png";